import React from "react";

import BarChart from "./BarChart";
import PieChart from "./PieChart";
import LineChart from "./LineChart";
import AreaChart from "./AreaChart";

const ChartRenderer = ({ chart }) => {

  switch (chart.type?.toLowerCase()) {

    case "bar":
      return <BarChart chart={chart} />;

    case "pie":
      return <PieChart chart={chart} />;

    case "line":
      return <LineChart chart={chart} />;

    case "area":
      return <AreaChart chart={chart} />;

    default:
      return (
        <div className="h-72 flex justify-center items-center text-gray-500">
          Unsupported Chart : {chart.type}
        </div>
      );
  }

};

export default ChartRenderer;